import { useParams, useLocation } from 'react-router-dom';
import { useAxiosInterceptor } from '../../../../../../api/wrappers';
import HeroSection from '../../../../../../components/conduct-risk/HeroSection';
import { routesMap } from '../../../../../../routes/routesMap';
import PerformanceReclamiContainer from '../../../../../../components/conduct-risk/drivers/PerformanceReclamiContainer';
import FilialiAPremioContainer from '../../../../../../components/conduct-risk/drivers/FilialiAPremioContainer';
import RicaviContainer from '../../../../../../components/conduct-risk/drivers/RicaviContainer';
import FocusPicchiRicaviContainer from '../../../../../../components/conduct-risk/drivers/FocusPicchiRicaviContainer';
import FocusKpiEFEOContainer from '../../../../../../components/conduct-risk/drivers/FocusKpiEFEOContainer';
import CorrelazioneICFContainer from '../../../../../../components/conduct-risk/drivers/CorrelazioneICFContainer';
import GestoriGlobalAdvisorContainer from '../../../../../../components/conduct-risk/drivers/GestoriGlobalAdvisorContainer';
import FocusAreeContainer from '../../../../../../components/conduct-risk/drivers/FocusAreeContainer';
import FruizioneFormazioneContainer from '../../../../../../components/conduct-risk/drivers/FruizioneFormazioneContainer';
import SaltoDiFasceContainer from '../../../../../../components/conduct-risk/drivers/SaltoDiFasceContainer';
import IncrementoCommissioniNetteContainer from '../../../../../../components/conduct-risk/drivers/IncrementoCommissioniNetteContainer';
import EstensioneAnalisiPicchiRicaviContainer from '../../../../../../components/conduct-risk/drivers/EstensioneAnalisiPicchiRicaviContainer';
import IncrementoFlussoNettoRisparmioContainer from '../../../../../../components/conduct-risk/drivers/IncrementoFlussoNettoRisparmioContainer';
import DecrementoFlussoNettoContainer from '../../../../../../components/conduct-risk/drivers/DecrementoFlussoNettoContainer';
import OutlierClusteringFilialiContainer from '../../../../../../components/conduct-risk/drivers/OutlierClusteringFilialiContainer';
import InvestigationSummaryContainer from '../../../../../../components/conduct-risk/drivers/InvestigationSummaryContainer';
import { DRIVER_NAMES, slugToDriverNumber, INVESTIGATION_SUMMARY_SLUG, INVESTIGATION_SUMMARY_NAME } from '../../../../../../utils/conductRiskDrivers';

const DRIVER_CONTAINERS: Record<number, React.FC<{ reportId: string }>> = {
  1:  PerformanceReclamiContainer,
  2:  FilialiAPremioContainer,
  3:  RicaviContainer,
  4:  FocusPicchiRicaviContainer,
  5:  FocusKpiEFEOContainer,
  6:  CorrelazioneICFContainer,
  7:  GestoriGlobalAdvisorContainer,
  8:  FocusAreeContainer,
  9:  FruizioneFormazioneContainer,
  // ─── Investigation drivers ─────────────────────────────
  10: SaltoDiFasceContainer,
  11: IncrementoCommissioniNetteContainer,
  12: OutlierClusteringFilialiContainer,
  13: EstensioneAnalisiPicchiRicaviContainer,
  14: IncrementoFlussoNettoRisparmioContainer,
  15: DecrementoFlussoNettoContainer,
};

const ConductRiskDriverDetailPage = () => {
  useAxiosInterceptor();
  const { name = '', driverSlug = '' } = useParams<{ name: string; driverSlug: string }>();
  const location = useLocation();
  const reportName: string = decodeURIComponent(name) || 'Report';
  const reportId = (location.state?.id as string | undefined) ?? '';

  // Sezione speciale "Aggregazione Evidenze Investigation": non e' un driver
  // (nessun numero), ma viene mostrata in una pagina come i driver.
  const isSummary = driverSlug === INVESTIGATION_SUMMARY_SLUG;
  const driverNumber = isSummary ? null : slugToDriverNumber(driverSlug);
  const driverName = isSummary
    ? INVESTIGATION_SUMMARY_NAME
    : driverNumber !== null ? DRIVER_NAMES[driverNumber] : `Driver ${driverSlug}`;

  const DriverContainer = driverNumber !== null ? DRIVER_CONTAINERS[driverNumber] : undefined;

  return (
    <div>
      <HeroSection
        title={driverName}
        description="Carica la fonte e consulta i risultati dell'analisi."
        breadcrumbLinks={[
          { url: routesMap.HOME_PAGE, title: 'Home' },
          { url: routesMap.CONDUCT_RISK_HOME, title: 'Conduct Risk' },
          { url: routesMap.CONDUCT_RISK_REPORT_PAGE, title: 'Report' },
          { url: routesMap.CONDUCT_RISK_REPORT_DETAIL(reportName), title: reportName, state: { id: reportId } },
          { url: '#', title: driverName },
        ]}
      />
      {isSummary ? (
        <InvestigationSummaryContainer reportId={reportId} />
      ) : DriverContainer ? (
        <DriverContainer reportId={reportId} />
      ) : (
        <div className="p-6 text-sm text-gray-400">Driver non ancora implementato.</div>
      )}
    </div>
  );
};

export default ConductRiskDriverDetailPage;
